// When may the Panorama loading screen come down? THE answer App's Panorama block waits on.
//
// Idan 2026-09-29: the photo alone is not enough. On a site whose panorama runs on an Autodesk
// model, the flags you move by, the 3D overlay, the floor buttons and the minimap all need that
// model — so the screen stays up until every model has settled, the same rule the 3D view uses
// (modelLoadProgress.ts). A site with no ready model releases on the photo, as before.
//
// Whether a model is coming is only known once the site's ACC links are in; until then a photo
// that is already up waits ('undecided') rather than releasing into a scene that starts loading
// a moment later. Every wait still ends: a failed links fetch counts as known, a viewer error
// reports ready, and useViewerBlocker's hard cap is the last resort.

export type PanoramaBlockStep = 'photo' | 'undecided' | 'model' | 'release';

export function getPanoramaBlockStep({ photoReady, siteLinksKnown, expects3DModel, modelsReady }: {
  photoReady: boolean;
  siteLinksKnown: boolean;
  expects3DModel: boolean;
  modelsReady: boolean;
}): PanoramaBlockStep {
  if (!photoReady) return 'photo';
  if (expects3DModel) return modelsReady ? 'release' : 'model';
  return siteLinksKnown ? 'release' : 'undecided';
}
